var globalFunctions = require('./globalFunctions.js');

module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title-long">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>1&-1.5</li> '+
                            '<li>X&-1.5</li> '+
                            '<li>2&-1.5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>1&+1.5</li> '+
                            '<li>X&+1.5</li> '+
                            '<li>2&+1.5</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title-long">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                         '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="1&-1.5" data-betCode="114" class="bet-choose" data-odd="'+quotes.Under15_1+'">'+globalFunctions.checkQuotes(quotes.Under15_1)+'</li> '+
                                '<li data-betType="X&-1.5" data-betCode="14" class="bet-choose" data-odd="'+quotes.Under15_X+'">'+globalFunctions.checkQuotes(quotes.Under15_X)+'</li> '+
                                '<li data-betType="2&-1.5" data-betCode="214" class="bet-choose" data-odd="'+quotes.Under15_2+'">'+globalFunctions.checkQuotes(quotes.Under15_2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="1&+1.5" data-betCode="116" class="bet-choose" data-odd="'+quotes.Over15_1+'">'+globalFunctions.checkQuotes(quotes.Over15_1)+'</li> '+
                                '<li data-betType="X&+1.5" data-betCode="16" class="bet-choose" data-odd="'+quotes.Over15_X+'">'+globalFunctions.checkQuotes(quotes.Over15_X)+'</li> '+
                                '<li data-betType="2&+1.5" data-betCode="216" class="bet-choose" data-odd="'+quotes.Over15_2+'">'+globalFunctions.checkQuotes(quotes.Over15_2)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/final_score_and_under_over_1.js
// module id = 2016
// module chunks = 4